import media from 'style-utils/responsive-utils/media/media';
import styled from 'styled-components';

export const AppHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 5rem;
  padding: 0 1.5rem;
  background-color: #ffffff;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  ${media.desktop`
    filter:unset;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.06);
    padding: 0 5rem 0 1.6rem;
  `}
`;
AppHeader.displayName = 'AppHeader';
